import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';

@inheritSerialization(AbstractApproval)
export class ClientFeeSchedule extends AbstractApproval {
  @autoserialize
  additionalPassengerFee: number;

  @autoserialize
  baseFare: number;

  @autoserialize
  baseRiderFee: number;

  @autoserialize
  bookingFee: number;

  @autoserialize
  distanceRate: number;

  @autoserialize
  fareCalculatorId: number;

  @autoserialize
  id: number;

  @autoserialize
  loadFee: number;

  @autoserialize
  loadFeeBaseDistance: number;

  @autoserialize
  maximumInvoiceAmount: number;

  @autoserialize
  mileageRate: number;

  @autoserialize
  fuelSurchargeRate: number;

  @autoserialize
  minimumFare: number;

  @autoserialize
  platformFee: number;

  @autoserialize
  providerIncentiveInvoiced: boolean;

  @autoserialize
  providerTollReimbursementInvoiced: boolean;

  @autoserialize
  requestFeeChargedOnRiderCancel: boolean;

  @autoserialize
  riderCancellationFee: number;

  @autoserialize
  clientCancellationFee: number;

  @autoserialize
  clientNoShowFee: number;

  @autoserialize
  riderFeeBaseDistance: number;

  @autoserialize
  riderFeeDistanceRate: number;

  @autoserialize
  noshowInvoiced: boolean;

  @autoserialize
  lateCancellationInvoiced: boolean;

  @autoserialize
  serviceLevelId: number;

  @autoserialize
  timeRate: number;

  @autoserialize
  totalRiderFeeDeductedFromInvoice: boolean;

  @autoserialize
  transitProgramId: number;
}
